import { type DirectiveBinding, type ObjectDirective } from 'vue'
declare function gtag(event: string, name: string, args: any)
const gtagDirective: ObjectDirective<HTMLElement, any> = {
  mounted(el, binding, vnode) {

    const event = binding.arg != null ? binding.arg : 'click'
    if (event == 'click') {
      el.addEventListener(
        'click',
        () => {
          if (!import.meta.env.PROD) {
            return
          }
          const label = binding.value != null ? binding.value : ''
          gtag('event', 'click', {
            event_category: 'button',
            event_label: label,
            value: 1
          })
        },
        true
      )
    }
  }
}

export default gtagDirective
